const DISMISS_KEY = "ceoweb_pwa_install_dismissed_at";
const DISMISS_COOLDOWN = 14 * 24 * 60 * 60 * 1000;

let deferredPrompt = null;

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)")?.matches ||
  window.navigator.standalone === true;

export const isIos = () =>
  (
    /iphone|ipad|ipod/i.test(window.navigator.userAgent || "") ||
    (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1)
  ) && !window.MSStream;

const recentlyDismissed = () => {
  try {
    const at = Number(window.localStorage.getItem(DISMISS_KEY) || 0);
    return at > 0 && Date.now() - at < DISMISS_COOLDOWN;
  } catch (error) {
    return false;
  }
};

export const bindInstallPrompt = (onAvailable, onResult) => {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    if (!recentlyDismissed() && !isStandalone()) {
      onAvailable?.({ native: true, ios: false });
    }
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    onResult?.("accepted");
  });

  if (isIos() && !isStandalone() && !recentlyDismissed()) {
    onAvailable?.({ native: false, ios: true });
  }
};

export const requestInstall = async () => {
  if (deferredPrompt) {
    await deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    const outcome = choice?.outcome === "accepted" ? "accepted" : "dismissed";
    deferredPrompt = null;
    if (outcome === "dismissed") {
      try {
        window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
      } catch (error) {
        // Ignore storage restrictions.
      }
    }
    window.dispatchEvent(new CustomEvent("ceoweb:pwa:install-result", {
      detail: { outcome },
    }));
    return outcome;
  }

  if (isIos()) return "ios-instructions";
  return "unsupported";
};
